import { TemplateData } from './htmlTemplates';

export const viralTextTemplate = {
  id: 'viral-text',
  name: '爆款文字',
  description: '突出文字内容，适合标题党和关键词强调',
  category: 'text-focused',
  generate: (data: TemplateData) => `
    <!DOCTYPE html>
    <html lang="zh-CN">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Cover</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .cover {
          width: 400px;
          height: 600px;
          background: #ffffff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 40px;
          font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
          position: relative;
          overflow: hidden;
        }

        .brand-mark {
          position: absolute;
          top: 20px;
          right: 20px;
          font-size: 20px;
          opacity: 0.6;
        }

        .title {
          font-size: 42px;
          font-weight: 900;
          color: #000000;
          text-align: center;
          line-height: 1.1;
          margin-bottom: 25px;
          letter-spacing: -1px;
        }

        .title-highlight {
          background: linear-gradient(45deg, ${data.theme.primaryColor}, ${data.theme.accentColor});
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          position: relative;
        }

        .title-highlight::after {
          content: '';
          position: absolute;
          bottom: -5px;
          left: 0;
          right: 0;
          height: 8px;
          background: ${data.theme.accentColor};
          opacity: 0.3;
          border-radius: 4px;
        }

        .subtitle {
          font-size: 20px;
          color: #333333;
          text-align: center;
          line-height: 1.3;
          font-weight: 500;
        }

        .keyword {
          background: ${data.theme.accentColor};
          color: white;
          padding: 2px 8px;
          border-radius: 12px;
          font-weight: 700;
          margin: 0 2px;
        }

        .accent-line {
          position: absolute;
          bottom: 80px;
          left: 50%;
          transform: translateX(-50%);
          width: 60px;
          height: 4px;
          background: ${data.theme.primaryColor};
          border-radius: 2px;
        }
      </style>
    </head>
    <body>
      <div class="cover">
        <div class="brand-mark">${data.theme.logo}</div>
        <h1 class="title">
          <span class="title-highlight">${data.title}</span>
        </h1>
        <p class="subtitle">${data.subtitle.replace(/(\S{2,4})/g, '<span class="keyword">$1</span>')}</p>
        <div class="accent-line"></div>
      </div>
    </body>
    </html>
  `
};
